import React, { useState } from "react";
import { footerSocials } from "../data/data";

export default function SocialsLinks() {
  const [socials] = useState(footerSocials);
  return (
    <ul className="flex items-center justify-center mt-6">
      {socials.map(({ id, title, image, url }) => (
        <li key={id} className="mx-3">
          <a href={url} target="_blank" rel="noopenner noreferrer">
            <img src={image} alt={title} title={title} className="w-10" />
          </a>
        </li>
      ))}
    </ul>
  );
}
